import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f161fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-part-a" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 7,
  class: "part-a-footer"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_SwipeStepper = _resolveComponent("SwipeStepper")
  const _component_FormHeaderTcNote = _resolveComponent("FormHeaderTcNote")
  const _component_FormHeader = _resolveComponent("FormHeader")
  const _component_FormPartAOverview = _resolveComponent("FormPartAOverview")
  const _component_FormPartAPracticeAreas = _resolveComponent("FormPartAPracticeAreas")
  const _component_FormPartATrustAccountDetails = _resolveComponent("FormPartATrustAccountDetails")
  const _component_FormPartADeclaration = _resolveComponent("FormPartADeclaration")
  const _component_FormPartAConfirmation = _resolveComponent("FormPartAConfirmation")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")
  const _component_SessionExpired = _resolveComponent("SessionExpired")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isSectionLoading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_SwipeStepper, {
      navSteps: _ctx.navSteps,
      showHelpBtn: true,
      showFaqBtn: true
    }, null, 8, ["navSteps"]),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.complianceFormA.practice?.trustCoordinator?.id)
        ? (_openBlock(), _createBlock(_component_FormHeaderTcNote, { key: 0 }))
        : _createCommentVNode("", true),
      (!_ctx.isSectionLoading)
        ? (_openBlock(), _createBlock(_component_FormHeader, {
            key: 1,
            formName: _ctx.formName,
            formDesc: _ctx.formDesc
          }, null, 8, ["formName", "formDesc"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.overview)
        ? (_openBlock(), _createBlock(_component_FormPartAOverview, {
            key: 2,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[0] || (_cache[0] = $event => ((_ctx.isSectionLoading) = $event)),
            onSetFormDesc: _cache[1] || (_cache[1] = $event => (_ctx.setFormDescription($event)))
          }, null, 8, ["isSectionLoading"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.practiceAreas)
        ? (_openBlock(), _createBlock(_component_FormPartAPracticeAreas, {
            key: 3,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[2] || (_cache[2] = $event => ((_ctx.isSectionLoading) = $event)),
            formPartAData: _ctx.formPartAData,
            "onUpdate:formPartAData": _cache[3] || (_cache[3] = $event => ((_ctx.formPartAData) = $event)),
            onValidForm: _cache[4] || (_cache[4] = $event => (_ctx.validationForm(1, $event)))
          }, null, 8, ["isSectionLoading", "formPartAData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.trustAccountDetails)
        ? (_openBlock(), _createBlock(_component_FormPartATrustAccountDetails, {
            key: 4,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[5] || (_cache[5] = $event => ((_ctx.isSectionLoading) = $event)),
            formPartAData: _ctx.formPartAData,
            "onUpdate:formPartAData": _cache[6] || (_cache[6] = $event => ((_ctx.formPartAData) = $event)),
            onValidForm: _cache[7] || (_cache[7] = $event => (_ctx.validationForm(2, $event)))
          }, null, 8, ["isSectionLoading", "formPartAData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.declaration)
        ? (_openBlock(), _createBlock(_component_FormPartADeclaration, {
            key: 5,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[8] || (_cache[8] = $event => ((_ctx.isSectionLoading) = $event)),
            formPartAData: _ctx.formPartAData,
            "onUpdate:formPartAData": _cache[9] || (_cache[9] = $event => ((_ctx.formPartAData) = $event)),
            onValidForm: _cache[10] || (_cache[10] = $event => (_ctx.validationForm(3, $event)))
          }, null, 8, ["isSectionLoading", "formPartAData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.confirmation)
        ? (_openBlock(), _createBlock(_component_FormPartAConfirmation, {
            key: 6,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[11] || (_cache[11] = $event => ((_ctx.isSectionLoading) = $event))
          }, null, 8, ["isSectionLoading"]))
        : _createCommentVNode("", true),
      (!_ctx.isSectionLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.isSaving)
              ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                  key: 0,
                  loadingText: _ctx.savingText,
                  class: "mr-4"
                }, null, 8, ["loadingText"]))
              : _createCommentVNode("", true),
            (_ctx.backButtonVisible)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-outline mr-2",
                  onClick: _cache[12] || (_cache[12] = $event => (_ctx.goBack())),
                  disabled: _ctx.isSaving || _ctx.isSectionLoading
                }, _toDisplayString(_ctx.backButtonText), 9, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.currentSection !== _ctx.$Section.declaration && _ctx.currentSection !== _ctx.$Section.overview && _ctx.currentSection !== _ctx.$Section.confirmation)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-secondary mr-2",
                  disabled: _ctx.isSaving || _ctx.isSectionLoading,
                  onClick: _cache[13] || (_cache[13] = $event => (_ctx.saveSection(false, true)))
                }, "Save", 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: !_ctx.canGoNext() || _ctx.isSaving || _ctx.isSectionLoading,
              onClick: _cache[14] || (_cache[14] = $event => (_ctx.goNext()))
            }, [
              _createTextVNode(_toDisplayString(_ctx.nextButtonText), 1),
              _hoisted_7
            ], 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmSaveClose",
      modalOpened: true
    }, null, 512),
    (_ctx.showSessionExpiredModal)
      ? (_openBlock(), _createBlock(_component_SessionExpired, {
          key: 1,
          modalOpened: _ctx.showSessionExpiredModal,
          onClose: _cache[15] || (_cache[15] = $event => (_ctx.exitForm()))
        }, null, 8, ["modalOpened"]))
      : _createCommentVNode("", true)
  ]))
}